export const measurements = {
  AQI: 3,
  x: [
    '01/03/2025',
    '02/03/2025',
    '03/03/2025',
    '04/03/2025',
    '05/03/2025',
    '06/03/2025',
    '07/03/2025',
    '08/03/2025',
    '09/03/2025',
    '10/03/2025',
    '11/03/2025',
    '12/03/2025',
    '13/03/2025',
    '14/03/2025',
    '15/03/2025',
    '16/03/2025',
    '17/03/2025',
    '18/03/2025',
    '19/03/2025',
    '20/03/2025',
    '21/03/2025',
    '22/03/2025',
    '23/03/2025',
    '24/03/2025',
    '25/03/2025',
    '26/03/2025',
    '27/03/2025',
    '28/03/2025',
    '29/03/2025',
    '30/03/2025',
    '31/03/2025',
  ],
  y: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  data: [
    6,
    3,
    8,
    1,
    7,
    9,
    5,
    4,
    4,
    7,
    3,
    6,
    2,
    4,
    8,
    3,
    3,
    5,
    4,
    1,
    1,
    3,
    6,
    10,
    2,
    5,
    1,
    8,
    1,
    8,
    5,
  ],
};

export const AQIColors = {
  low: '#31CF00',
  moderate: '#FF9A00',
  high: '#FF0000',
  veryHigh: '#64002B',
};

export const getAQITextAndColor = (band: number) => {
  if (band <= 3) return { text: 'Low', color: AQIColors.low };
  if (band >= 4 && band <= 6)
    return { text: 'Moderate', color: AQIColors.moderate };
  if (band >= 7 && band <= 9) return { text: 'High', color: AQIColors.high };
  if (band > 9) return { text: 'Very High', color: AQIColors.veryHigh };
  return { text: 'N/A', color: 'N/A' };
};

export const formatReportEventDate = (inputDate: string): string => {
  const date = new Date(inputDate);

  const options: Intl.DateTimeFormatOptions = { month: 'long' };
  const month = date.toLocaleDateString('en-US', options);

  const day = date.getDate();

  const suffix = (day: number): string => {
    if (day >= 11 && day <= 13) {
      return 'th';
    }
    switch (day % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };

  return `${month} ${day}${suffix(day)}`;
};

export const formatDateToMonthDay = (dateString: string): string => {
  const date = new Date(dateString);

  const options: Intl.DateTimeFormatOptions = {
    month: 'short',
    day: '2-digit',
  };
  const formattedDate = date.toLocaleDateString('en-US', options);

  return formattedDate;
};

export const formatDetailedHeatmapTimestamps = (isoString: string): string => {
  const date = new Date(isoString);

  const days: string[] = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const day: string = days[date.getUTCDay()];

  const dayOfMonth: number = date.getUTCDate();

  const getOrdinalSuffix = (n: number): string => {
    if (n >= 11 && n <= 13) return 'th';
    switch (n % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };

  return `${day} ${dayOfMonth}${getOrdinalSuffix(dayOfMonth)}`;
};

export const formatTableDate = (dateString: string): string => {
  const [year, month, day] = dateString.split('-').map(Number);
  const date = new Date(year, month - 1, day);

  const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const dayOfWeek = weekdays[date.getDay()];

  const getOrdinal = (n: number) => {
    if (n > 3 && n < 21) return 'th';
    const suffixes = ['th', 'st', 'nd', 'rd'];
    return suffixes[n % 10] || 'th';
  };

  return `${dayOfWeek} ${day}${getOrdinal(day)}`;
};

export const createAQIMatrix = (
  hourlyTimeStamps: string[],
  hourlyAQIBands: number[],
): number[][] => {
  const ts: { [key: string]: number[] } = {};
  hourlyTimeStamps.forEach((hts, id) => {
    const date = hts.split('T')[0];
    const band = hourlyAQIBands[id];
    if (!ts[date]) ts[date] = [band];
    else {
      ts[date].push(band);
    }
  });
  const matrix = Object.values(ts);
  return matrix.length ? matrix : [];
};

export const getHourlyPercentages = (arr: number[]) => {
  // let counts = new Array(6).fill(0);
  // let total = arr.length;

  // arr.forEach(num => {
  //     if (num >= 1 && num <= 6) {
  //         counts[num - 1]++;
  //     }
  // });

  // return counts.map(count => (total > 0 ? (count / total) * 100 : 0));

  let counts = new Array(6).fill(0);
  let total = arr.filter((val: number | null) => val !== null).length;

  arr.forEach((num) => {
    if (num >= 1 && num <= 6) {
      counts[num - 1]++;
    }
  });

  let percentages = counts.map((count) => Math.round((count / total) * 100));

  let sum = percentages.reduce((a, b) => a + b, 0);
  let diff = 100 - sum;

  while (diff !== 0) {
    let index = percentages.findIndex((p) => p > 0);
    if (index === -1) break;

    percentages[index] += diff > 0 ? 1 : -1;
    diff += diff > 0 ? -1 : 1;
  }

  return percentages;
};

export const getDominantPollutant = (
  no2: number | string,
  o3: number | string,
  pm25: number | string,
  pm10: number | string,
): string => {
  const pollutants = ['NO2', 'O3', 'PM2.5', 'PM10'];
  const values = [no2, o3, pm25, pm10];

  const numericValues = values.filter((v) => v !== 'N/A') as number[];
  if (numericValues.length === 0) return 'N/A';

  const maxVal = Math.max(...numericValues);

  const dominantIndices = values
    .map((v, i) => (v === maxVal ? i : -1))
    .filter((i) => i !== -1);

  const dominantPollutants = dominantIndices.map((i) => pollutants[i]);

  return dominantPollutants.length === 4
    ? 'All'
    : dominantPollutants.length === 3
    ? `${dominantPollutants[0]}, ${dominantPollutants[1]} & ${dominantPollutants[2]}`
    : dominantPollutants.join(' & ');
};

export const convertToTimestampMeasurementDataRange = (
  date: string,
): { start: number; end: number } => {
  const [year, month] = date.split('-').map(Number);
  const now = new Date();
  const isCurrentMonth =
    now.getFullYear() === year && now.getMonth() + 1 === month;
  const start = Number(`${year}${String(month).padStart(2, '0')}010000`);
  let end;
  if (isCurrentMonth) {
    // If the month hasn't expired, return the previous day at 23:59
    const prevDay = new Date(now);
    prevDay.setDate(now.getDate() - 1);
    end = Number(
      `${year}${String(month).padStart(2, '0')}${String(
        prevDay.getDate(),
      ).padStart(2, '0')}2359`,
    );
  } else {
    // If the month has expired, return the last day of that month at 23:59
    const lastDay = new Date(year, month, 0).getDate();
    end = Number(`${year}${String(month).padStart(2, '0')}${lastDay}2359`);
  }

  return { start, end };
};

export const convertCurrentDateYYYYMMDD = () => {
  const date = new Date();
  const pad = (num: number) => String(num).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate(),
  )}`;
};

export const getReportMonthName = (dateStr: string): string => {
  const date = new Date(dateStr);
  return date.toLocaleString('en-US', { month: 'long' });
};

export const isSlotAValid = (data: any) => {
  return (
    data['Hourly average on the hour'].slotA &&
    data['Hourly average on the hour'].slotA.hasOwnProperty('dateTime') &&
    data['Hourly average on the hour'].slotA.hasOwnProperty('NO2') &&
    data['Hourly average on the hour'].slotA.hasOwnProperty('O3') &&
    data['Hourly average on the hour'].slotA.hasOwnProperty(
      'particulatePM25',
    ) &&
    data['Hourly average on the hour'].slotA.hasOwnProperty('particulatePM10')
  );
};

export const getMonthlyTimestamps = (startDate: string): string[] => {
  const inputDate = new Date(startDate);
  const month = inputDate.getMonth();
  const year = inputDate.getFullYear();

  const firstDay = new Date(Date.UTC(year, month, 1));

  const lastDay = new Date(Date.UTC(year, month + 1, 0));
  const dates: string[] = [];

  for (
    let currentDate = firstDay;
    currentDate <= lastDay;
    currentDate.setUTCDate(currentDate.getUTCDate() + 1)
  ) {
    const formattedDate = currentDate.toISOString().split('.')[0] + '+00:00';
    dates.push(formattedDate);
  }

  return dates;
};

export const getHourlyTimestamps = (date: string): string[] => {
  const inputDate = new Date(date);
  const month = inputDate.getMonth();
  const year = inputDate.getFullYear();

  const firstHour = new Date(Date.UTC(year, month, 1, 0, 0, 0));

  const lastHour = new Date(Date.UTC(year, month + 1, 0, 23, 0, 0));
  const hours: string[] = [];

  for (
    let currentHour = firstHour;
    currentHour <= lastHour;
    currentHour.setUTCHours(currentHour.getUTCHours() + 1)
  ) {
    const formattedDate = currentHour.toISOString().split('.')[0] + '+00:00';
    hours.push(formattedDate);
  }

  return hours;
};

/* Charts */

// First page bar chart
export const createFirstPageBarChart = (res3: any, sConfig: any) => {
  const { AQIs } = res3.AQIDataOutputs.find(
    (data: any) => data.label === 'daily',
  );
  const { band } = AQIs.find(
    (item: { AQISpecies: string; band: number[] }) =>
      item.AQISpecies.toLowerCase() === 'aqi',
  );
  const hasNulls = band.includes(null);
  const bandNames = Object.values(sConfig!).map((config: any) => config.name);
  const bandColors = Object.values(sConfig!).map((config: any) => config.color);
  const bands = Object.keys(sConfig!).reduce((acc, num) => {
    (acc as { [key: number]: number })[+num] = 0;
    return acc;
  }, {});
  const days: { [key: number]: number } = hasNulls ? { ...bands, 0: 0 } : bands;

  band.forEach((b: number) => {
    if (b === null) {
      days[0] = days[0] + 1;
    } else {
      days[b] = days[b] + 1;
    }
  });

  const airQualityBands = hasNulls ? [...bandNames, 'No Data'] : bandNames;

  const daysCount = hasNulls
    ? [...Object.values(days).slice(1), Object.values(days)[0]]
    : Object.values(days);

  const colors = hasNulls ? [...bandColors, '#e2e8f0'] : bandColors;

  const annotations = daysCount.map((day: number, id: number) => {
    if (day > 0) {
      return {
        x: airQualityBands[id],
        y: day + 0.8,
        text: String(day),
        font: {
          family: 'Arial',
          size: 24,
          color: '#000',
        },
        showarrow: false,
      };
    }
  });

  const trace: any = {
    x: airQualityBands,
    y: daysCount,
    type: 'bar',
    marker: { color: colors },
  };

  const layout = {
    xaxis: {
      title: {
        text: 'EU Daily Air Quality Index',
        font: {
          size: 24,
          color: '#000',
        },
      },
      tickfont: { size: 24 },
    },
    yaxis: {
      title: {
        text: 'Number of Days',
        font: {
          size: 24,
          color: '#000',
        },
      },
      range: [0, Math.max(...daysCount) + 5],
      tickmode: 'linear',
      tick0: 0,
      dtick: 5,
      ticks: '',
      ticklen: 5,
      showgrid: true,
      showticks: false,
      tickfont: { size: 24 },
    },
    showlegend: false,
    annotations,
  };
  return { trace, layout };
};

// Fourth page charts

function createMatrix(timestamps: string[], bands: number[]) {
  const matrix = [];
  let subArray: any[] = [];
  timestamps.forEach((tS, id) => {
    if (id === 0) {
      const curDayPos = new Date(tS).getDay();
      const array =
        curDayPos > 1 ? Array(curDayPos - 1).fill(undefined) : [bands[id]];
      if (curDayPos > 1) {
        subArray.push(...array, bands[id]);
      } else {
        subArray.push(...array);
      }
    } else {
      if (subArray.length === 7) {
        matrix.push(subArray);
        subArray = [];
      }
      subArray.push(bands[id]);
    }
  });
  if (subArray.length) {
    const array = Array(7 - subArray.length).fill(undefined);
    matrix.push([...subArray, ...array]);
  }

  return matrix.reverse();
}

export const createDailyHeatmap = (
  aqiData: any,
  speciesConfig: any,
  timeStamps: string[],
) => {
  const { timeStamps: aqiTimeStamps, AQIs } = aqiData.AQIDataOutputs.find(
    (data: any) => data.label === 'daily',
  );
  const { band } = AQIs.find(
    (item: any) => item.AQISpecies.toLowerCase() === 'aqi',
  );
  let updatedBands: (number | null | undefined)[] = [];
  if (aqiTimeStamps.length !== timeStamps.length) {
    let aqiTimeStampsObject: { [key: string]: number | null } = {};
    aqiTimeStamps.forEach((tS: string, id: number) => {
      aqiTimeStampsObject[tS] = band[id];
    });
    for (let i = 0; i < timeStamps.length; i++) {
      if (timeStamps[i] in aqiTimeStampsObject)
        updatedBands.push(aqiTimeStampsObject[timeStamps[i]]);
      else updatedBands.push(null);
    }
  }
  const zMatrix = createMatrix(
    timeStamps,
    updatedBands.length ? updatedBands : band,
  );
  const weekdays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  const hasMatrixNulls = zMatrix.flat().filter((val) => val === null).length;
  const updatedZMatrix = hasMatrixNulls
    ? zMatrix.map((row) => row.map((value) => (value === null ? 0 : value)))
    : zMatrix;
  const bandColors = Object.keys(speciesConfig!).reduce((acc, num) => {
    (acc as { [key: number]: string })[+num] = speciesConfig![+num].color;
    return acc;
  }, {});
  const bands = Object.keys(speciesConfig!);
  const bandNames = Object.values(speciesConfig!).map((val: any) => val.name);
  const colors = !hasMatrixNulls
    ? bandColors
    : {
        0: '#e2e8f0', // Null(No Data)
        ...bandColors,
      };

  const days = timeStamps.map((date: string, i: number) => {
    const parsedDate = new Date(date);
    const day = parsedDate.getUTCDate();

    const suffix = [11, 12, 13].includes(day)
      ? 'th'
      : ['st', 'nd', 'rd'][(day % 10) - 1] || 'th';

    return `${day}${suffix}`;
  });

  let annotations: any = [];
  let dayIndex = 0;

  [...updatedZMatrix].reverse().forEach((array, id) => {
    const reversedY = updatedZMatrix.length - id - 1;
    for (let i = 0; i < array.length; i++) {
      if (array[i] !== undefined) {
        annotations.push({
          x: weekdays[i],
          y: reversedY,
          text: days[dayIndex],
          showarrow: false,
          font: { size: 30, color: '#000' },
          align: 'center',
        });
        dayIndex++;
      }
    }
  });

  const trace = {
    x: weekdays,
    z: updatedZMatrix,
    type: 'heatmap',
    xgap: 3,
    ygap: 3,
    colorscale: Object.entries(colors).map(([key, color]: any) => [
      (hasMatrixNulls ? key : key - 1) / (hasMatrixNulls ? 6 : 5),
      color,
    ]),
    showscale: true,
    zmin: hasMatrixNulls ? 0 : bands[0],
    zmax: bands[bands.length - 1],
    colorbar: {
      tickvals: !hasMatrixNulls ? bands : [0, ...bands],
      ticktext: !hasMatrixNulls ? bandNames : ['No Data', ...bandNames],
      ticks: 'outside',
      ticklen: 5,
      tickwidth: 1,
      tickcolor: 'black',
      tickangle: 0,
      tickmode: 'array',
      showticks: true,
      tickfont: { size: 30 },
    },
  };

  const layout = {
    xaxis: { showgrid: false, tickfont: { size: 30 } },
    yaxis: {
      showticklabels: false,
      ticks: '',
      showgrid: false,
      zeroline: false,
    },
    annotations,
    margin: { t: 40, b: 55, l: 60, r: 0 },
    coloraxis: {
      colorbar: {
        x: 1.05,
        tickvals: !hasMatrixNulls ? bands : [0, ...bands],
        ticktext: !hasMatrixNulls ? bandNames : ['No Data', ...bandNames],
        ticks: 'outside',
        ticklen: 5,
        tickwidth: 1,
        tickcolor: 'black',
        tickangle: 0,
        tickfont: { size: 25, color: 'black' },
        tickmode: 'array',
      },
    },
  };

  return { trace, layout };
};

export const createDetailedHeatmap = (
  aqiData: any,
  speciesConfig: any,
  timeStamps: string[],
) => {
  const { AQIDataOutputs } = aqiData;
  const aqis = AQIDataOutputs.find((data: any) => data.label === 'daily');
  const { AQIs, timeStamps: aqiTimeStamps } = aqis;
  const AQIBand = AQIs.find(
    (specie: { AQISpecies: string; band: number[] | null[] }) =>
      specie.AQISpecies === 'AQI',
  ).band;
  const NO2Band = AQIs.find(
    (specie: { AQISpecies: string; band: number[] | null[] }) =>
      specie.AQISpecies === 'NO2',
  ).band;
  const O3Band = AQIs.find(
    (specie: { AQISpecies: string; band: number[] | null[] }) =>
      specie.AQISpecies === 'O3',
  ).band;
  const PM25Band = AQIs.find(
    (specie: { AQISpecies: string; band: number[] | null[] }) =>
      specie.AQISpecies === 'particulatePM25',
  ).band;
  const PM10Band = AQIs.find(
    (specie: { AQISpecies: string; band: number[] | null[] }) =>
      specie.AQISpecies === 'particulatePM10',
  ).band;
  const updatedAQIBand = [];
  const updatedNO2Band = [];
  const updatedO3Band = [];
  const updatedPM25Band = [];
  const updatedPM10Band = [];
  if (aqiTimeStamps.length !== timeStamps.length) {
    let aqiTimeStampsObject: {
      [key: string]: { [key: string]: number | null };
    } = {};
    aqiTimeStamps.forEach((tS: string, id: number) => {
      aqiTimeStampsObject[tS] = {
        AQI: AQIBand[id],
        NO2: NO2Band[id],
        O3: O3Band[id],
        PM25: PM25Band[id],
        PM10: PM10Band[id],
      };
    });
    for (let i = 0; i < timeStamps.length; i++) {
      if (timeStamps[i] in aqiTimeStampsObject) {
        updatedAQIBand.push(aqiTimeStampsObject[timeStamps[i]].AQI);
        updatedNO2Band.push(aqiTimeStampsObject[timeStamps[i]].NO2);
        updatedO3Band.push(aqiTimeStampsObject[timeStamps[i]].O3);
        updatedPM25Band.push(aqiTimeStampsObject[timeStamps[i]].PM25);
        updatedPM10Band.push(aqiTimeStampsObject[timeStamps[i]].PM10);
      } else {
        updatedAQIBand.push(null);
        updatedNO2Band.push(null);
        updatedO3Band.push(null);
        updatedPM25Band.push(null);
        updatedPM10Band.push(null);
      }
    }
  }
  const isBandNull = (aqiTimeStamps.length !== timeStamps.length
    ? [
        ...updatedAQIBand,
        ...updatedNO2Band,
        ...updatedO3Band,
        ...updatedPM25Band,
        ...updatedPM10Band,
      ]
    : [...AQIBand, ...NO2Band, ...O3Band, ...PM25Band, ...PM10Band]
  ).find((val: number | null) => val === null);
  const formattedTimeStamps = timeStamps.map((tS: string) =>
    formatDateToMonthDay(tS),
  );
  const updatedZMatrix = (aqiTimeStamps.length !== timeStamps.length
    ? [
        updatedNO2Band,
        updatedO3Band,
        updatedPM25Band,
        updatedPM10Band,
        [undefined],
        updatedAQIBand,
      ]
    : [NO2Band, O3Band, PM25Band, PM10Band, [undefined], AQIBand]
  ).map((row) => row.map((value: any) => (value === null ? 0 : value)));
  const bandNamesColors: { [key: string]: string }[] = Object.values(
    speciesConfig!,
  );
  const bands = Object.keys(speciesConfig!);

  const trace = {
    x: formattedTimeStamps,
    y: ['NO2', 'O3', 'PM2.5', 'PM10', '', 'Daily AQI'],
    z: updatedZMatrix,
    type: 'heatmap',
    ygap: 10,
    zmin: isBandNull === null ? 0 : bands[0],
    zmax: bands[bands.length - 1],
    showscale: false,
    layer: 'below',
    colorscale:
      isBandNull === null
        ? [
            [0, '#e2e8f0'],
            [1 / 6, bandNamesColors[0].color],
            [2 / 6, bandNamesColors[1].color],
            [3 / 6, bandNamesColors[2].color],
            [4 / 6, bandNamesColors[3].color],
            [5 / 6, bandNamesColors[4].color],
            [1, bandNamesColors[5].color],
          ]
        : [
            [0, bandNamesColors[0].color],
            [0.2, bandNamesColors[1].color],
            [0.4, bandNamesColors[2].color],
            [0.6, bandNamesColors[3].color],
            [0.8, bandNamesColors[4].color],
            [1, bandNamesColors[5].color],
          ],
  };

  const legendTraces = [];

  if (isBandNull === null) {
    legendTraces.push({
      x: [null],
      y: [null],
      mode: 'markers',
      type: 'scatter',
      marker: {
        color: '#e2e8f0',
        size: 24,
        symbol: 'square',
        line: { width: 0 },
      },
      name: 'No Data',
    });
  }

  const legendItems = [...bandNamesColors];

  legendItems.forEach(({ color, name }) => {
    legendTraces.push({
      x: [null],
      y: [null],
      mode: 'markers',
      type: 'scatter',
      marker: {
        color: color,
        size: 24,
        symbol: 'square',
        line: { width: 0 },
      },
      name: name,
    });
  });

  const layout = {
    xaxis: {
      layer: 'above',
      title: {
        text: 'Date',
        font: {
          size: 24,
          color: '#000',
        },
      },
      tickfont: { size: 24 },
      tickangle: -45,
      tickposition: 'start',
      tickson: 'boundaries',
    },
    yaxis: {
      title: {
        text: 'Pollutant',
        font: {
          size: 24,
          color: '#000',
        },
        standoff: 10,
      },
      showticklabels: true,
      tickvals: [0, 1, 2, 3, 5],
      ticktext: [
        'NO<sub>2</sub>',
        'O<sub>3</sub>',
        'PM<sub>2.5</sub>',
        'PM<sub>10</sub>',
        'Daily AQI',
      ],
      ticks: 'outside',
      ticklen: 5,
      layer: 'above',
      zeroline: false,
      tickfont: { size: 24 },
    },
    legend: {
      orientation: 'h',
      x: 0.5,
      xanchor: 'center',
      y: 1.02,
      yanchor: 'bottom',
      font: {
        size: 24,
      },
    },
    margin: { t: 0, b: 130, l: 135, r: 0 },
  };
  const gridLines: any = [];

  [0, 1, 2, 3, 5].forEach((yVal) => {
    gridLines.push({
      type: 'line',
      xref: 'paper',
      yref: 'y',
      x0: 0,
      x1: 1,
      y0: yVal,
      y1: yVal,
      line: { color: 'rgba(255,255,255,0.6)', width: 1 },
    });
  });

  formattedTimeStamps.forEach((_: any, i: number) => {
    gridLines.push({
      type: 'line',
      xref: 'x',
      yref: 'paper',
      x0: i - 0.5,
      x1: i - 0.5,
      y0: 0,
      y1: 1,
      line: { color: 'rgba(255,255,255,0.6)', width: 1 },
    });
  });

  (layout as any).shapes = gridLines;
  return { trace, layout, legendTraces };
};

// Fifth page charts

export const getFifthBarChartBandName = (aqiData: any, speciesConfig: any) => {
  const { AQIDataOutputs } = aqiData;
  const aqis = AQIDataOutputs.find((data: any) => data.source === 'direct');
  const { AQIs } = aqis;
  const hourlyAQIBands = AQIs.find(
    (item: { AQISpecies: string; band: number[] }) =>
      item.AQISpecies.toLowerCase().includes('aqi'),
  ).band;
  const airQualityBands = Object.values(speciesConfig!).map(
    (val: any) => val.name,
  );
  const daysCount = getHourlyPercentages(hourlyAQIBands);
  let bandName = airQualityBands[0];
  let highestDay = daysCount[0];
  for (let i = 1; i < daysCount.length; i++) {
    if (daysCount[i] && daysCount[i] > highestDay) {
      highestDay = daysCount[i];
      bandName = airQualityBands[i];
    }
  }
  return bandName;
};

export const createFifthPageBarChart = (aqiData: any, speciesConfig: any) => {
  const { AQIDataOutputs } = aqiData;
  const aqis = AQIDataOutputs.find((data: any) => data.source === 'direct');
  const { AQIs } = aqis;
  const hourlyAQIBands = AQIs.find(
    (item: { AQISpecies: string; band: number[] }) =>
      item.AQISpecies.toLowerCase().includes('aqi'),
  ).band;
  const airQualityBands = Object.values(speciesConfig!).map(
    (val: any) => val.name,
  );
  const daysCount = getHourlyPercentages(hourlyAQIBands);

  const colors = Object.values(speciesConfig!).map((val: any) => val.color);

  const annotations = daysCount.map((day: number, id: number) => {
    if (day) {
      return {
        x: airQualityBands[id],
        y: day + 2,
        text: String(day),
        font: {
          family: 'Arial',
          size: 30,
          color: '#000',
        },
        showarrow: false,
      };
    }
  });

  const trace: any = {
    x: airQualityBands,
    y: daysCount,
    type: 'bar',
    marker: { color: colors },
  };

  const layout = {
    xaxis: {
      // title: {
      //     text: 'Air Quality Band',
      //     font: {
      //         size: 30,
      //         color: '#000'
      //     }
      // },
      tickfont: { size: 30 },
    },
    yaxis: {
      title: {
        text: 'Percentage of Month (%)',
        font: {
          size: 30,
          color: '#000',
        },
      },
      range: [0, Math.max(...daysCount) + 10],
      tickmode: 'linear',
      tick0: 0,
      dtick: 10,
      ticks: '',
      ticklen: 5,
      showgrid: true,
      showticks: false,
      tickfont: { size: 30 },
    },
    showlegend: false,
    annotations,
    margin: {
      t: 0,
      b: 90,
      l: 100,
      r: 40,
    },
  };

  return { trace, layout };
};

export const createHourlyHeatmap = (
  aqiData: any,
  speciesConfig: any,
  timeStamps: string[],
  hourlyTimestamps: string[],
) => {
  const { AQIDataOutputs } = aqiData;
  const formattedTimeStamps = timeStamps.map((tS: string) =>
    formatDetailedHeatmapTimestamps(tS),
  );
  const aqis = AQIDataOutputs.find((data: any) => data.source === 'direct');
  const { AQIs, timeStamps: hourlyTS } = aqis;
  const hourlyAQIBands = AQIs.find(
    (item: { AQISpecies: string; band: number[] }) =>
      item.AQISpecies.toLowerCase().includes('aqi'),
  ).band;
  const updatedHourlyAQIBands = [];
  if (hourlyTS.length !== hourlyTimestamps.length) {
    const hourlyAQIObject: { [key: string]: number | null } = {};
    hourlyTS.forEach((tS: string, id: number) => {
      hourlyAQIObject[tS] = hourlyAQIBands[id];
    });
    for (let i = 0; i < hourlyTimestamps.length; i++) {
      if (hourlyTimestamps[i] in hourlyAQIObject)
        updatedHourlyAQIBands.push(hourlyAQIObject[hourlyTimestamps[i]]);
      else updatedHourlyAQIBands.push(null);
    }
  }
  const zMatrix = createAQIMatrix(
    hourlyTimestamps,
    hourlyTS.length !== hourlyTimestamps.length
      ? updatedHourlyAQIBands
      : hourlyAQIBands,
  );
  const hasMatrixNulls = zMatrix.flat().filter((val) => val === null).length;
  const updatedZMatrix = hasMatrixNulls
    ? zMatrix.map((row) => row.map((value) => (value === null ? 0 : value)))
    : zMatrix;
  const bandNames = Object.values(speciesConfig!).map((val: any) => val.name);
  const bands = Object.keys(speciesConfig!);
  const bandColors = Object.values(speciesConfig!).map((val: any) => val.color);
  const trace = {
    x: Array.from({ length: 24 }, (_, i) => `${String(i).padStart(2, '0')}:00`),
    y: formattedTimeStamps.reverse(),
    z: updatedZMatrix.reverse(),
    type: 'heatmap',
    xgap: 1,
    ygap: 1,
    zmin: hasMatrixNulls ? 0 : bands[0],
    zmax: bands[bands.length - 1],
    showscale: true,
    colorbar: {
      tickvals: hasMatrixNulls ? [0, ...bands] : bands,
      ticktext: hasMatrixNulls ? ['No Data', ...bandNames] : bandNames,
      ticks: 'outside',
      ticklen: 5,
      tickwidth: 1,
      tickcolor: 'black',
      tickangle: 0,
      tickfont: { size: 24 },
    },
    colorscale: hasMatrixNulls
      ? [
          [0, '#e2e8f0'],
          [1 / 6, bandColors[0]],
          [2 / 6, bandColors[1]],
          [3 / 6, bandColors[2]],
          [4 / 6, bandColors[3]],
          [5 / 6, bandColors[4]],
          [1, bandColors[5]],
        ]
      : [
          [0, bandColors[0]],
          [0.2, bandColors[1]],
          [0.4, bandColors[2]],
          [0.6, bandColors[3]],
          [0.8, bandColors[4]],
          [1, bandColors[5]],
        ],
  };

  const weekendRects = (formattedTimeStamps as any)
    .map((dateStr: string, id: number) =>
      dateStr.includes('Sat') || dateStr.includes('Sun') ? id : null,
    )
    .filter((id: number) => id !== null)
    .map((id: number) => ({
      type: 'rect',
      xref: 'paper',
      yref: 'y',
      x0: -0.15,
      x1: 0,
      y0: id - 0.45,
      y1: id + 0.45,
      fillcolor: 'gray',
      opacity: 0.3,
      layer: 'below',
      line: { width: 2, color: 'white' },
    }));

  const layout = {
    xaxis: {
      title: {
        text: 'Hour of Day',
        font: {
          size: 24,
          color: '#000',
        },
      },
      tickvals: [0, 4, 8, 12, 16, 20],
      ticktext: ['00:00', '04:00', '08:00', '12:00', '16:00', '20:00'],
      showgrid: false,
      tickfont: { size: 24 },
    },
    yaxis: {
      showticklabels: true,
      tickvals: formattedTimeStamps.map((_: string, id: number) => id),
      ticktext: formattedTimeStamps,
      ticks: 'outside',
      ticklen: 5,
      showgrid: false,
      zeroline: false,
      tickfont: { size: 24 },
    },
    shapes: weekendRects,
    margin: {
      t: 20,
      b: 135,
      l: 135,
      r: 0,
    },
  };

  return { trace, layout };
};

// Dynamic text

export const getBarChartText = (res3: any, sConfig: any) => {
  const { AQIs } = res3.AQIDataOutputs.find(
    (data: any) => data.label === 'daily',
  );
  const { band } = AQIs.find(
    (item: { AQISpecies: string; band: number[] }) =>
      item.AQISpecies.toLowerCase() === 'aqi',
  );
  if (band.every((value: number | null) => value === null || value === 0))
    return [];
  const bands = Object.keys(sConfig!).reduce((acc, num) => {
    (acc as { [key: number]: number })[+num] = 0;
    return acc;
  }, {});
  const days: { [key: number]: number } = { ...bands };

  band.forEach((b: number) => {
    if (typeof b === 'number') days[b] = days[b] + 1;
  });
  const reformattedBands: { [key: string]: number } = {};
  Object.entries(days).forEach(([key, value]) => {
    reformattedBands[sConfig[key].name] = value;
  });
  const severityOrder = Object.keys(reformattedBands);

  const maxVal = Math.max(...Object.values(reformattedBands));

  const maxEntries = severityOrder
    .map((label, index) => ({ label, index, value: reformattedBands[label] }))
    .filter((entry) => entry.value === maxVal);

  const primary = maxEntries[maxEntries.length - 1];
  const result: string[] = [primary.label];

  for (let i = severityOrder.length - 1; i > primary.index; i--) {
    const label = severityOrder[i];
    if (reformattedBands[label] > 0) {
      result.push(label);
      break;
    }
  }

  return result;
};

export const pollutantMap: Record<string, string> = {
  NO2: 'Nitrogen Dioxide (NO2)',
  O3: 'Ozone (O3)',
  'PM2.5': 'Fine Particulate (PM2.5)',
  PM10: 'Coarse Particulate Matter (PM10)',
};

export const getDailyHeatmapText = (
  aqiData: any,
  speciesConfig: any,
): string => {
  const { AQIs } = aqiData.AQIDataOutputs.find(
    (data: any) => data.label === 'daily',
  );
  const { band } = AQIs.find(
    (item: any) => item.AQISpecies.toLowerCase() === 'aqi',
  );
  if (band.every((b: number | null) => b === null)) return 'N/A';
  const maxBand = Math.max(...band);
  return speciesConfig[maxBand].name;
};

export const getTablePopulatedPollutantBands = (
  aqiTimeStamps: string[],
  timeStamps: string[],
  NO2Band: (number | null)[],
  O3Band: (number | null)[],
  PM25Band: (number | null)[],
  PM10Band: (number | null)[],
) => {
  const updatedNO2Band = [];
  const updatedO3Band = [];
  const updatedPM25Band = [];
  const updatedPM10Band = [];
  let aqiTimeStampsObject: {
    [key: string]: { [key: string]: number | null };
  } = {};
  aqiTimeStamps.forEach((tS: string, id: number) => {
    aqiTimeStampsObject[tS] = {
      NO2: NO2Band[id],
      O3: O3Band[id],
      PM25: PM25Band[id],
      PM10: PM10Band[id],
    };
  });
  for (let i = 0; i < timeStamps.length; i++) {
    if (timeStamps[i] in aqiTimeStampsObject) {
      updatedNO2Band.push(aqiTimeStampsObject[timeStamps[i]].NO2);
      updatedO3Band.push(aqiTimeStampsObject[timeStamps[i]].O3);
      updatedPM25Band.push(aqiTimeStampsObject[timeStamps[i]].PM25);
      updatedPM10Band.push(aqiTimeStampsObject[timeStamps[i]].PM10);
    } else {
      updatedNO2Band.push(null);
      updatedO3Band.push(null);
      updatedPM25Band.push(null);
      updatedPM10Band.push(null);
    }
  }
  return { updatedNO2Band, updatedO3Band, updatedPM25Band, updatedPM10Band };
};

export const safariHack = '-webkit-hyphens:none';
